<template>
<div>
  <VCard>
    <VCardText >
      
      <VRow>
        <VCol cols="6" md="3">
          <AppInput
            v-model="filters.userId"
            label="承辦人員"
            type="picker"
            item-title="label"
            item-value="value"
            placeholder="請輸入承辦人員"
            :picker="duUserPicker"
            :disabled="false"
            clearable
          />
        </VCol>
        <VCol cols="6" md="3">
          <AppInput
            v-model="filters.deptNoLike"
            label="協會代碼"
            type="picker"
            item-title="label"
            item-value="value"
            placeholder="請輸入協會代碼"
            :picker="duDepartmentPicker"
            :disabled="false"
            clearable
          />
        </VCol>
        <VCol cols="12" md="6" class="d-flex justify-end align-center">
          <div class="d-flex justify-end flex-wrap">
            <v-btn variant="tonal" color="primary" prepend-icon="tabler-plus" @click="openDialog(dialogAllStatus[0].value)">
              新增
            </v-btn>
            <v-btn variant="tonal" color="warning" prepend-icon="tabler-edit" 
            @click="openDialog(dialogAllStatus[1].value)" class="ml-3"
            :disabled="selectCounselor.length<1||selectCounselor.length>1"
            >
              修改
            </v-btn>
            <v-btn @click="deleteBtn" 
            color="error" 
            variant="tonal" 
            prepend-icon="tabler-trash" 
            class="ml-3"
            :disabled="selectCounselor.length<1"
            >
              刪除
            </v-btn>
          </div>
        </VCol>

      </VRow>
    </VCardText>
    <VDivider />
    

    <VDataTableServer 
    v-model:items-per-page="size"
    v-model:page="page"
    :items-length="totalData"
    v-model="selectCounselor"
    :headers="headers" 
    :items="items" 
    show-select 
    item-value="tbtca06VO.userId"
    >
      <template #bottom>
        <TablePagination
          v-model:page="page"
          v-model:size="size"
          :items-per-page="size"
          :total-items="totalData"
        />
      </template>
    </VDataTableServer>

  </VCard> 
  <v-dialog v-model="isDialogVisible" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>
      <v-card-text class="pa-1">
        <v-container>
          <v-form ref="formRef">
            <v-row>
              <v-col cols="6">
                <AppInput
                  v-if="dialogStatus==dialogAllStatus[0].value"
                  v-model="form.userId"
                  label="承辦人員"
                  type="picker"
                  item-title="label"
                  item-value="value"
                  placeholder="請輸入承辦人員"
                  :picker="duUserPicker"
                  :disabled="false"
                  clearable
                  :rules="[rules.required]"
                />
                <VRow v-else>
                  <VCol cols="5">
                    <AppInput
                      
                      v-model="form.userId"
                      label="承辦人員帳號"
                      type="text"
                      item-title="label"
                      item-value="value"
                      placeholder=""
                      :disabled="false"
                      readonly
                    />
                  </VCol>
                  <VCol cols="7">
                    <AppInput
                      v-model="form.name"
                      label="承辦人員姓名"
                      type="text"
                      :disabled="false"
                      readonly
                    />
                  </VCol>
                </VRow>
              </v-col>
              <v-col cols="6">
                <AppInput
                  v-model="form.remark"
                  label="備註"
                  type="text"
                  item-title="label"
                  item-value="value"
                  placeholder="請輸入備註"
                  :disabled="false"
                />
              </v-col>
              <v-col cols="12" style="max-height:65%">
                <AssociationAutoComplete
                v-model:select-array="form.association"
                />
              </v-col>

            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="closeDialog">取消</v-btn>
        <v-btn color="blue darken-1" @click="save">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive } from "vue";
import AssociationAutoComplete from './AssociationAutoCompleteComponenet.vue'

definePage({
  meta: {
    action: "manage",
    subject: "FNCOUNSELOR",
  },
});
const trySelect= ref([])

const formRef=ref(null)
const rules = ref({
  required: (value: any) => {
    if (Array.isArray(value)){
      return value.length>0 || '此欄位為必填'
    }else{
      return !!value || '此欄位為必填'
    }
  },
});
const dialogAllStatus=[
  {
    key:'新增',
    value:'add',
  },
  {
    key:'修改',
    value:'edit',
  },
]
const dialogStatus= ref(dialogAllStatus[0].value)
// 篩選條件
const filters = reactive({
    userId: '',
    deptNoLike: null,
  });

const headers= reactive([
  { title: '承辦人員', key: 'cname' },
  { title: '承辦人員帳號', key: 'tbtca06VO.userId' },
  { title: '組別', key: 'userdeptName' },
  { title: '協會', key: 'deptNoNames' },
  { title: '備註', key: 'tbtca06VO.remark' }
])

const page=ref(1)
const size=ref( 10)
const totalData=ref(0)
// 各協會輔導員設定table
const items = reactive([])
const selectCounselor=ref([])

// autocomplete -association
const selectAssociation=ref([])

const isDialogVisible= ref(false)
const dialogTitle = ref('');

// form
const form= reactive({
  id:"",
  userId: '',
  association: [],
  remark: '',
  name:'',
})

// 


// API---------------
// 👉 協會API
const { data: subDeptsData, execute: fetchSubDept } = await useApi<any>(createUrl('/du/org/class/getSubDept', {
  query: {
    upperDepNo: 'asso' ,
  },
}))
const associations = computed(()=>{
  return subDeptsData.value?subDeptsData.value:[]
  }
)

// 清單
const fetchData =async() =>{
  let userId = filters.userId?toCode(filters.userId):null
  let deptNoLike = filters.deptNoLike?toCode(filters.deptNoLike):null
  try {
    const response = await $api('/tca/fnAssociationCounselor/get', {
      method: 'POST',
      body: {
        userId,
        deptNoLike,
        page:page.value-1,
        size:size.value,
      },
    });
    totalData.value = response.totalElements
    items.splice(0 , items.length , ...response.content)
    selectCounselor.value.splice(0 , selectCounselor.value.length )
  } catch (error) {
    totalData.value = 0
    items.splice(0 , items.length )
    console.error('Error during fetch:', error);
  }
}

// 新增API
const add =async(body) =>{
  try {
    const response = await $api('/tca/fnAssociationCounselor/add', {
      method: 'POST',
      body: body,
    });
    console.log(response)
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
    });
    
    fetchData()
  } catch (error) {
    $swal({
      position: 'top-end',
      icon: 'error',
      title: '失敗 請稍後再試',
    });
  }
}
// 修改API
const update =async(body) =>{
  try {
    const response = await $api('/tca/fnAssociationCounselor/update', {
      method: 'POST',
      body: body,
    });
    console.log(response)
    $swal({
      position: 'top-end',
      icon: 'success',
      title: '編輯成功',
    });

       const style = document.createElement('style');
      style.innerHTML = `
        .my-custom-container {
          z-index: 100000000000 !important;
        }
        .my-custom-popup {
          z-index: 100000000000 !important;
        }
      `;
      document.head.appendChild(style);
    isDialogVisible.value=false
    fetchData()
  } catch (error) {
    $swal({
      position: 'top-end',
      icon: 'error',
      title: '失敗 請稍後再試',
    });
  }
}
// 刪除API
const deleteBtn =async() =>{
  try {
    await $api('/tca/fnAssociationCounselor/delete', {
      method: 'POST',
      body: selectCounselor.value,
    });
    selectCounselor.value=[]
    fetchData()
  } catch (error) {
    $swal({
      position: 'top-end',
      icon: 'error',
      title: '失敗 請稍後再試',
    });
  }
}





const openDialog = (type: string) => {
  dialogTitle.value = type === dialogAllStatus[0].value ? '新增承辦人員' : '修改承辦人員';
  dialogStatus.value = type
  if(type == dialogAllStatus[0].value){
    form.id=""
    form.userId=""
    form.association=[]
    form.remark=''
    form.name = ''
  }else{
    const [data] = items.filter((it)=> it.tbtca06VO.id === selectCounselor.value[0])
    console.log(data)
    form.id=data.tbtca06VO?.id
    form.userId=data.tbtca06VO?.id
    form.name = data.cname
    form.association=data.tbtca06VO?.deptNo.split(",")
    form.remark=data.tbtca06VO?.remark
  }
  isDialogVisible.value = true;
}

// v-form 驗證
const submitForm=async() => {
  const { valid } = await formRef.value.validate();
  return valid
}

const closeDialog =()=>{
  isDialogVisible.value = false
}

const dialogData = async() =>{
  let data ={
    id:form.id,
    userId:form.userId,
    deptNos:form.association.toString(),
    remark:form.remark,
  }
  return data
}

const save =async()=>{
  const valid = await submitForm();
  // 儲存邏輯
  if(valid){
    isDialogVisible.value=false
    if(dialogStatus.value==dialogAllStatus[0].value){
      //新增時
        const data =await dialogData()
        console.log(data)
        delete data.id
        data.userId = toCode(data.userId)
        add(data)
    }else{
      //修改時
      console.log('ialogActionStatus[1].value')
        const data =await dialogData()
        console.log(data)
        update({...data, deptNo :data.deptNos})
    }
  }
}

watch(size,()=>{
  fetchData()
})
watch(page,()=>{
  fetchData()
})
watch(filters,()=>{
  fetchData()
})
onMounted(()=>{
  fetchData()
})
</script>

<style scoped>
.mx-2 {
  margin-left: 8px;
  margin-right: 8px;
}
</style>
